export const getNotificationOption = <
	T extends NotificationOptions = NotificationOptions
>(
	title: string,
	{ tag: _tag, badge, icon, ..._options }: T
) => {
	const tag = `${_tag ? `${_tag}-` : ''}${title}`.replace(' ', '_');

	return {
		renotify: true,
		tag,
		timestamp: Date.now(),
		badge: badge ?? icon,
		icon: icon ?? badge,
		..._options,
	};
};
